var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpProximity1070296000000(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.773 76.59h-0.41797l0.41797-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 75.363l-1.2578 1.2266h-0.41797l1.6797-1.6367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 74.137l-2.5156 2.4531h-0.41797l2.9375-2.8633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 72.91l-3.7773 3.6836h-0.41797l4.1953-4.0898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 71.684l-5.0352 4.9102h-0.41797l5.4531-5.3164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 70.453l-6.293 6.1367h-0.41797l6.7148-6.5469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 69.227l-7.5508 7.3633h-0.41797l7.9727-7.7734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 68l-8.8125 8.5898h-0.41797l9.2305-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 66.773l-10.07 9.8164h-0.41797l10.488-10.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 65.547l-11.328 11.047h-0.41797l11.75-11.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 64.316l-12.586 12.273h-0.41797l13.008-12.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 63.09l-13.848 13.5h-0.41797l14.266-13.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 61.863l-15.105 14.727h-0.41797l15.523-15.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 60.637l-16.363 15.953v-0.41016l16.363-15.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.934 60.227l-15.523 15.137v-0.41016l15.105-14.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.676 60.227l-14.266 13.91v-0.41016l13.848-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.418 60.227l-13.008 12.684v-0.41016l12.586-12.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.156 60.227l-11.75 11.453v-0.41016l11.328-11.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.898 60.227l-10.488 10.227v-0.41016l10.07-9.8164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.641 60.227l-9.2305 9v-0.41016l8.8125-8.5898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.383 60.227l-7.9727 7.7734v-0.41016l7.5508-7.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.121 60.227l-6.7148 6.5469v-0.41016l6.293-6.1367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.863 60.227l-5.4531 5.3164v-0.41016l5.0352-4.9102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.605 60.227l-4.1953 4.0898v-0.41016l3.7773-3.6836z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.348 60.227l-2.9375 2.8633v-0.41016l2.5156-2.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.086 60.227l-1.6797 1.6367v-0.41016l1.2578-1.2266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.828 60.227l-0.41797 0.41016v-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 58.184h-0.86328l0.86328-0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 56.922l-1.293 1.2578h-0.85547l2.1484-2.0977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 55.656l-2.582 2.5234h-0.85547l3.4375-3.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 54.398l-3.875 3.7852h-0.86328l4.7383-4.6211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 53.137l-5.1641 5.043h-0.86328l6.0273-5.8789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 51.887l-6.457 6.2969h-0.86328l7.3203-7.1406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 50.625l-7.7539 7.5547h-0.85547l8.6094-8.3984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 49.367l-9.043 8.8164h-0.85547l9.9023-9.6602v0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 48.109l-10.336 10.074h-0.85547l11.191-10.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 46.848l-11.629 11.332h-0.85547l12.484-12.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 45.59l-12.91 12.594h-0.86328l13.773-13.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 44.332l-14.203 13.852h-0.87109l15.074-14.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 43.07l-15.496 15.109h-0.87109l16.363-15.949v0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.766 41.816l-16.355 15.949v-0.84375l15.5-15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.477 41.816l-15.066 14.688v-0.84375l14.211-13.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.191 41.816l-13.781 13.43v-0.84375l12.918-12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.898 41.816l-12.488 12.172v-0.84375l11.621-11.328h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.609 41.816l-11.199 10.91v-0.83594l10.328-10.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.316 41.816l-9.9062 9.6523v-0.83594l9.0391-8.8164h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.02 41.816l-8.6094 8.3945v-0.83594l7.7539-7.5547h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.727 41.816l-7.3203 7.1328v-0.83594l6.4609-6.2969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.438 41.816l-6.0273 5.875v-0.83594l5.1719-5.0352h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.145 41.816l-4.7383 4.6133v-0.83594l3.8789-3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.855 41.816l-3.4453 3.3555v-0.83594l2.5898-2.5195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.562 41.816l-2.1523 2.0977v-0.83594l1.293-1.2578h0.86328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.273 41.816l-0.86328 0.83594v-0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 39.773h-0.41797l0.41797-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 38.547l-1.2578 1.2266h-0.41797l1.6797-1.6367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 37.316l-2.5156 2.4531h-0.41797l2.9375-2.8633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 36.09l-3.7773 3.6836h-0.41797l4.1953-4.0898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 34.863l-5.0352 4.9102h-0.41797l5.4531-5.3164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 33.637l-6.293 6.1367h-0.41797l6.7148-6.5469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 32.41l-7.5508 7.3633h-0.41797l7.9727-7.7734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 31.184l-8.8125 8.5898h-0.41797l9.2305-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 29.953l-10.07 9.8164h-0.41797l10.488-10.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 28.727l-11.328 11.047h-0.41797l11.75-11.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 27.5l-12.586 12.273h-0.41797l13.008-12.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 26.273l-13.848 13.5h-0.41797l14.266-13.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 25.047l-15.105 14.727h-0.41797l15.523-15.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 23.816l-16.363 15.953v-0.41016l16.363-15.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.75 23.41l-15.523 15.137v-0.41016l15.105-14.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.492 23.41l-14.266 13.91v-0.41016l13.848-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.234 23.41l-13.008 12.684v-0.41016l12.586-12.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.977 23.41l-11.75 11.453v-0.41016l11.328-11.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.715 23.41l-10.488 10.227v-0.41016l10.07-9.8164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.457 23.41l-9.2305 9v-0.41016l8.8125-8.5898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.199 23.41l-7.9727 7.7734v-0.41016l7.5508-7.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.941 23.41l-6.7148 6.5469v-0.41016l6.293-6.1367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.684 23.41l-5.4531 5.3164v-0.41016l5.0352-4.9102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.422 23.41l-4.1953 4.0898v-0.41016l3.7773-3.6836z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.164 23.41l-2.9375 2.8633v-0.41016l2.5156-2.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.906 23.41l-1.6797 1.6367v-0.41016l1.2578-1.2266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.648 23.41l-0.41797 0.41016v-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 58.184h-0.86328l0.86328-0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 56.922l-1.293 1.2578h-0.85547l2.1484-2.0977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 55.656l-2.582 2.5234h-0.85547l3.4375-3.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 54.398l-3.875 3.7852h-0.86328l4.7383-4.6211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 53.137l-5.1641 5.043h-0.86328l6.0273-5.8789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 51.887l-6.457 6.2969h-0.86328l7.3203-7.1406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 50.625l-7.7539 7.5547h-0.85547l8.6094-8.3984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 49.367l-9.043 8.8164h-0.85547l9.9023-9.6602v0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 48.109l-10.336 10.074h-0.85547l11.191-10.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 46.848l-11.629 11.332h-0.85547l12.484-12.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 45.59l-12.91 12.594h-0.86328l13.773-13.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 44.332l-14.203 13.852h-0.87109l15.074-14.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 43.07l-15.496 15.109h-0.87109l16.363-15.949v0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.586 41.816l-16.355 15.949v-0.84375l15.5-15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.293 41.816l-15.066 14.688v-0.84375l14.211-13.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.008 41.816l-13.781 13.43v-0.84375l12.918-12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.719 41.816l-12.488 12.172v-0.84375l11.621-11.328h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.426 41.816l-11.199 10.91v-0.83594l10.328-10.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.137 41.816l-9.9062 9.6523v-0.83594l9.0391-8.8164h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.836 41.816l-8.6094 8.3945v-0.83594l7.7539-7.5547h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.547 41.816l-7.3203 7.1328v-0.83594l6.4609-6.2969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.254 41.816l-6.0273 5.875v-0.83594l5.1719-5.0352h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.965 41.816l-4.7383 4.6133v-0.83594l3.8789-3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.672 41.816l-3.4453 3.3555v-0.83594l2.5898-2.5195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.383 41.816l-2.1523 2.0977v-0.83594l1.293-1.2578h0.86328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.09 41.816l-0.86328 0.83594v-0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.363 58.184v-0.41797l-0.41016 0.41797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.137 58.184l1.2266-1.2578v-0.41797l-1.6367 1.6797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.91 58.184l2.4531-2.5156v-0.41797l-2.8633 2.9375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.684 58.184l3.6836-3.7773v-0.41797l-4.0898 4.1953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.453 58.184l4.9102-5.0352v-0.41797l-5.3164 5.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.227 58.184l6.1367-6.293v-0.41797l-6.5469 6.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 58.184l7.3633-7.5508v-0.41797l-7.7734 7.9727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.773 58.184l8.5898-8.8125v-0.41797l-9 9.2305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.547 58.184l9.8164-10.07v-0.41797l-10.227 10.488z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.316 58.184l11.047-11.328v-0.41797l-11.453 11.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.0898 58.184l12.273-12.586v-0.41797l-12.684 13.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.8633 58.184l13.5-13.848v-0.41797l-13.91 14.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.6367 58.184l14.727-15.105v-0.41797l-15.137 15.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.4102 58.184l15.953-16.363h-0.41016l-15.953 16.363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 57.344l15.137-15.523h-0.41016l-14.727 15.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 56.082l13.91-14.266h-0.41016l-13.5 13.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 54.824l12.684-13.008h-0.41016l-12.273 12.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 53.566l11.453-11.75h-0.41016l-11.043 11.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 52.309l10.227-10.488h-0.41016l-9.8164 10.066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 51.051l9-9.2305h-0.41016l-8.5898 8.8086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 49.789l7.7734-7.9727h-0.41016l-7.3633 7.5547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 48.531l6.5469-6.7148h-0.41016l-6.1367 6.2969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 47.273l5.3164-5.4531h-0.41016l-4.9062 5.0312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 46.016l4.0898-4.1953h-0.41016l-3.6797 3.7734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 44.754l2.8633-2.9375h-0.41016l-2.4531 2.5195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 43.496l1.6367-1.6797h-0.41016l-1.2266 1.2617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 42.238l0.41016-0.42188h-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.816 58.184h16.363v-16.363h-16.363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95 58.184v-0.41797l-0.41016 0.41797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.773 58.184l1.2266-1.2617v-0.41797l-1.6367 1.6797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.547 58.184l2.4531-2.5195v-0.41797l-2.8633 2.9375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.316 58.184l3.6836-3.7773v-0.41797l-4.0898 4.1953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.09 58.184l4.9102-5.0352v-0.41797l-5.3164 5.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.863 58.184l6.1367-6.2969v-0.41797l-6.5469 6.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.637 58.184l7.3633-7.5547v-0.41797l-7.7734 7.9727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.41 58.184l8.5898-8.8125v-0.41797l-9 9.2305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.184 58.184l9.8164-10.07v-0.42188l-10.227 10.492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.953 58.184l11.047-11.332v-0.41797l-11.453 11.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.727 58.184l12.273-12.59v-0.41797l-12.684 13.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.5 58.184l13.5-13.848v-0.41797l-13.91 14.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.273 58.184l14.727-15.105v-0.42188l-15.137 15.527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.047 58.184l15.953-16.367h-0.41016l-15.953 16.363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 57.344l15.137-15.523h-0.41016l-14.727 15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 56.082l13.91-14.266h-0.41016l-13.5 13.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 54.824l12.684-13.008h-0.41016l-12.273 12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 53.566l11.453-11.75h-0.41016l-11.047 11.328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 52.309l10.227-10.488h-0.41016l-9.8164 10.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 51.051l9-9.2305h-0.41016l-8.5898 8.8125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 49.789l7.7734-7.9727h-0.41016l-7.3633 7.5508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 48.531l6.5469-6.7148h-0.41016l-6.1367 6.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 47.273l5.3164-5.4531h-0.41016l-4.9102 5.0352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 46.016l4.0898-4.1953h-0.41016l-3.6836 3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 44.754l2.8633-2.9375h-0.41016l-2.4531 2.5156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 43.496l1.6367-1.6797h-0.41016l-1.2266 1.2578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.637 42.238l0.41016-0.41797h-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 95h-0.41797l0.41797-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 93.773l-1.2617 1.2266h-0.41797l1.6797-1.6367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 92.547l-2.5195 2.4531h-0.41797l2.9375-2.8633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 91.316l-3.7773 3.6836h-0.41797l4.1953-4.0898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 90.09l-5.0352 4.9102h-0.41797l5.4531-5.3164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 88.863l-6.2969 6.1367h-0.41797l6.7148-6.5469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 87.637l-7.5547 7.3633h-0.41797l7.9727-7.7734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 86.41l-8.8125 8.5898h-0.41797l9.2305-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 85.184l-10.07 9.8164h-0.42188l10.492-10.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 83.953l-11.332 11.047h-0.41797l11.75-11.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 82.727l-12.59 12.273h-0.41797l13.008-12.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 81.5l-13.848 13.5h-0.41797l14.266-13.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 80.273l-15.105 14.727h-0.42188l15.527-15.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 79.047l-16.367 15.953v-0.41016l16.363-15.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.344 78.637l-15.523 15.137v-0.41016l15.105-14.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.082 78.637l-14.266 13.91v-0.41016l13.848-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.824 78.637l-13.008 12.684v-0.41016l12.59-12.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.566 78.637l-11.75 11.453v-0.41016l11.328-11.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.309 78.637l-10.488 10.227v-0.41016l10.07-9.8164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.051 78.637l-9.2305 9v-0.41016l8.8125-8.5898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.789 78.637l-7.9727 7.7734v-0.41016l7.5508-7.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.531 78.637l-6.7148 6.5469v-0.41016l6.293-6.1367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.273 78.637l-5.4531 5.3164v-0.41016l5.0352-4.9102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.016 78.637l-4.1953 4.0898v-0.41016l3.7773-3.6836z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.754 78.637l-2.9375 2.8633v-0.41016l2.5156-2.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.496 78.637l-1.6797 1.6367v-0.41016l1.2578-1.2266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.238 78.637l-0.41797 0.41016v-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 76.59h-0.86328l0.86328-0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 75.332l-1.293 1.2578h-0.85547l2.1484-2.0977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 74.066l-2.582 2.5234h-0.85547l3.4375-3.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 72.809l-3.875 3.7852h-0.86328l4.7383-4.6211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 71.547l-5.1641 5.043h-0.86328l6.0273-5.8789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 70.293l-6.457 6.2969h-0.86328l7.3203-7.1406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 69.035l-7.7539 7.5547h-0.85547l8.6094-8.3984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 67.777l-9.043 8.8164h-0.85547l9.9023-9.6602v0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 66.516l-10.336 10.074h-0.85547l11.191-10.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 65.258l-11.629 11.332h-0.85547l12.484-12.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 64l-12.91 12.594h-0.86328l13.773-13.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 62.738l-14.203 13.852h-0.87109l15.074-14.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 61.48l-15.496 15.109h-0.87109l16.363-15.949v0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.176 60.227l-16.355 15.949v-0.84375l15.5-15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.883 60.227l-15.066 14.688v-0.84375l14.211-13.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.598 60.227l-13.781 13.43v-0.84375l12.918-12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.309 60.227l-12.488 12.172v-0.84375l11.621-11.328h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.016 60.227l-11.199 10.91v-0.83594l10.328-10.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.727 60.227l-9.9062 9.6523v-0.83594l9.0391-8.8164h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.43 60.227l-8.6094 8.3945v-0.83594l7.7539-7.5547h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.137 60.227l-7.3203 7.1328v-0.83594l6.4609-6.2969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.848 60.227l-6.0273 5.875v-0.83594l5.1719-5.0352h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.555 60.227l-4.7383 4.6133v-0.83594l3.8789-3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.262 60.227l-3.4453 3.3555v-0.83594l2.5898-2.5195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.973 60.227l-2.1523 2.0977v-0.83594l1.293-1.2578h0.86328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.68 60.227l-0.86328 0.83594v-0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 21.363h-0.41797l0.41797-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 20.137l-1.2578 1.2266h-0.41797l1.6797-1.6367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 18.91l-2.5156 2.4531h-0.41797l2.9375-2.8633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 17.684l-3.7773 3.6836h-0.41797l4.1953-4.0898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 16.453l-5.0352 4.9102h-0.41797l5.4531-5.3164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 15.227l-6.293 6.1367h-0.41797l6.7148-6.5469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 14l-7.5508 7.3633h-0.41797l7.9727-7.7734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 12.773l-8.8125 8.5898h-0.41797l9.2305-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 11.547l-10.07 9.8164h-0.41797l10.488-10.227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 10.316l-11.328 11.047h-0.41797l11.75-11.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 9.0898l-12.586 12.273h-0.41797l13.008-12.684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 7.8633l-13.848 13.5h-0.41797l14.266-13.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 6.6367l-15.105 14.727h-0.41797l15.523-15.137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 5.4102l-16.363 15.953v-0.41016l16.363-15.953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.344 5l-15.523 15.137v-0.41016l15.102-14.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.082 5l-14.266 13.91v-0.41016l13.848-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.824 5l-13.008 12.684v-0.41016l12.59-12.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.566 5l-11.75 11.453v-0.41016l11.332-11.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.309 5l-10.488 10.227v-0.41016l10.066-9.8164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.051 5l-9.2305 9v-0.41016l8.8086-8.5898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.789 5l-7.9727 7.7734v-0.41016l7.5547-7.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.531 5l-6.7148 6.5469v-0.41016l6.2969-6.1367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.273 5l-5.4531 5.3164v-0.41016l5.0312-4.9062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.016 5l-4.1953 4.0898v-0.41016l3.7734-3.6797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.754 5l-2.9375 2.8633v-0.41016l2.5195-2.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.496 5l-1.6797 1.6367v-0.41016l1.2617-1.2266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.238 5l-0.42188 0.41016v-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 39.773h-0.86328l0.86328-0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 38.512l-1.293 1.2578h-0.85547l2.1484-2.0977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 37.246l-2.582 2.5234h-0.85547l3.4375-3.3633z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 35.988l-3.875 3.7852h-0.86328l4.7383-4.6211z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 34.73l-5.1641 5.043h-0.86328l6.0273-5.8789z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 33.477l-6.457 6.2969h-0.86328l7.3203-7.1406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 32.219l-7.7539 7.5547h-0.85547l8.6094-8.3984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 30.957l-9.043 8.8164h-0.85547l9.9023-9.6602v0.84375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 29.699l-10.336 10.074h-0.85547l11.191-10.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 28.441l-11.629 11.332h-0.85547l12.484-12.172z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 27.18l-12.91 12.594h-0.86328l13.773-13.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 25.922l-14.203 13.852h-0.87109l15.074-14.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.184 24.66l-15.496 15.109h-0.87109l16.363-15.949v0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.176 23.41l-16.355 15.949v-0.84375l15.5-15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.883 23.41l-15.066 14.688v-0.84375l14.211-13.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.598 23.41l-13.781 13.43v-0.84375l12.918-12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.309 23.41l-12.488 12.172v-0.84375l11.621-11.328h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.016 23.41l-11.199 10.91v-0.83594l10.328-10.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.727 23.41l-9.9062 9.6523v-0.83594l9.0391-8.8164h0.87109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.43 23.41l-8.6094 8.3945v-0.83594l7.7539-7.5547h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.137 23.41l-7.3203 7.1328v-0.83594l6.4609-6.2969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.848 23.41l-6.0273 5.875v-0.83594l5.1719-5.0352h0.85547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.555 23.41l-4.7383 4.6133v-0.83594l3.8789-3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.262 23.41l-3.4453 3.3555v-0.83594l2.5898-2.5195z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.973 23.41l-2.1523 2.0977v-0.83594l1.293-1.2578h0.86328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.68 23.41l-0.86328 0.83594v-0.83594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.773 39.773v-0.41797l-0.41016 0.41797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.547 39.773l1.2266-1.2578v-0.41797l-1.6367 1.6797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.316 39.773l2.4531-2.5156v-0.41797l-2.8633 2.9375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.09 39.773l3.6836-3.7773v-0.41797l-4.0898 4.1953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.863 39.773l4.9102-5.0352v-0.41797l-5.3164 5.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.637 39.773l6.1367-6.293v-0.41797l-6.5469 6.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.41 39.773l7.3633-7.5508v-0.41797l-7.7734 7.9727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.184 39.773l8.5898-8.8125v-0.41797l-9 9.2305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.953 39.773l9.8164-10.07v-0.41797l-10.227 10.488z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.727 39.773l11.047-11.328v-0.41797l-11.453 11.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 39.773l12.273-12.586v-0.41797l-12.684 13.008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.273 39.773l13.5-13.848v-0.41797l-13.91 14.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.047 39.773l14.727-15.105v-0.41797l-15.137 15.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.816 39.773l15.953-16.363h-0.41016l-15.949 16.363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 38.934l15.137-15.523h-0.41016l-14.727 15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 37.676l13.91-14.266h-0.41016l-13.5 13.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 36.418l12.684-13.008h-0.41016l-12.273 12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 35.156l11.453-11.75h-0.41016l-11.043 11.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 33.898l10.227-10.488h-0.41016l-9.8164 10.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 32.641l9-9.2305h-0.41016l-8.5898 8.8125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 31.383l7.7734-7.9727h-0.41016l-7.3633 7.5508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 30.121l6.5469-6.7148h-0.41016l-6.1367 6.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 28.863l5.3164-5.4531h-0.41016l-4.9102 5.0352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 27.605l4.0898-4.1953h-0.41016l-3.6836 3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 26.348l2.8633-2.9375h-0.41016l-2.4531 2.5156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 25.086l1.6367-1.6797h-0.41016l-1.2266 1.2578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.41 23.828l0.41016-0.41797h-0.41016z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.59 76.59v-0.41797l-0.41016 0.41797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.363 76.59l1.2266-1.2578v-0.41797l-1.6367 1.6797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.137 76.59l2.4531-2.5156v-0.41797l-2.8633 2.9375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.91 76.59l3.6836-3.7773v-0.41797l-4.0898 4.1953z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.684 76.59l4.9102-5.0352v-0.41797l-5.3164 5.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.453 76.59l6.1367-6.293v-0.41797l-6.5469 6.7148z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.227 76.59l7.3633-7.5508v-0.41797l-7.7734 7.9727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68 76.59l8.5898-8.8125v-0.41797l-9 9.2305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.773 76.59l9.8164-10.07v-0.41797l-10.227 10.488z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.547 76.59l11.047-11.328v-0.41797l-11.453 11.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.316 76.59l12.273-12.586v-0.41797l-12.68 13.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.09 76.59l13.5-13.848v-0.41797l-13.91 14.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.863 76.59l14.727-15.105v-0.41797l-15.137 15.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.637 76.59l15.953-16.363h-0.41016l-15.953 16.363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 75.75l15.137-15.523h-0.41016l-14.727 15.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 74.492l13.91-14.266h-0.41016l-13.5 13.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 73.234l12.684-13.008h-0.41016l-12.273 12.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 71.977l11.453-11.75h-0.41016l-11.047 11.328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 70.715l10.227-10.488h-0.41016l-9.8164 10.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 69.457l9-9.2305h-0.41016l-8.5898 8.8125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 68.199l7.7734-7.9727h-0.41016l-7.3633 7.5508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 66.941l6.5469-6.7148h-0.41016l-6.1367 6.293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 65.684l5.3164-5.4531h-0.41016l-4.9102 5.0352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 64.422l4.0898-4.1953h-0.41016l-3.6836 3.7773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 63.164l2.8633-2.9375h-0.41016l-2.4531 2.5156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 61.906l1.6367-1.6797h-0.41016l-1.2266 1.2578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.227 60.648l0.41016-0.41797h-0.41016z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpProximity1070296000000);
export default __webpack_public_path__ + "static/media/np_proximity_1070296_000000.8cbd2bddd89bcae8b5ff89253a038e63.svg";
export { ForwardRef as ReactComponent };